import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { EngagementEventInput } from "@sales-ops-amplify/shared";
import {
  getPersonActivities,
  getPersonProfile,
  listPersonSequenceEnrollments,
} from "@/api/people";
import { createEngagement } from "@/api/engagements";

export function usePersonProfile(personId: string | undefined) {
  return useQuery({
    queryKey: ["people", "profile", personId],
    queryFn: () => getPersonProfile(personId!),
    enabled: !!personId,
    staleTime: 30_000,
  });
}

export function usePersonActivities(
  personId: string | undefined,
  types?: string[],
) {
  return useQuery({
    queryKey: ["people", "activities", personId, types ?? []],
    queryFn: () => getPersonActivities(personId!, { types }),
    enabled: !!personId,
    staleTime: 15_000,
  });
}

export function usePersonSequenceEnrollments(leadId: string | undefined) {
  return useQuery({
    queryKey: ["people", "sequences", leadId],
    queryFn: () => listPersonSequenceEnrollments(leadId!),
    enabled: !!leadId,
    staleTime: 30_000,
  });
}

export function useLogPersonActivity(personId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EngagementEventInput) => createEngagement(input),
    onSuccess: () => {
      if (personId) {
        void qc.invalidateQueries({
          queryKey: ["people", "activities", personId],
        });
      }
    },
  });
}
